import { createClient } from '@supabase/supabase-js';

// Same country project and keys as that country's portal site (set per Netlify site).
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!supabaseUrl || !supabasePublishableKey) {
  throw new Error(
    'Missing VITE_SUPABASE_URL or VITE_SUPABASE_PUBLISHABLE_KEY environment variables',
  );
}

export const supabase = createClient(supabaseUrl, supabasePublishableKey);
